import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Footer } from '../footer/footer';

@Component({
  selector: 'app-page-layout',
  imports: [RouterOutlet, Footer],
  templateUrl: './page-layout.html',
})
export class PageLayout {}
